import * as React from "react";

export default React.lazy(() => import(/* webpackChunkName: "reporting" */ "./Reporting"));
